<template>
  <div class="GdPage">
    <div class="back" @click="goBack()">
      <div class="backIcon">
        <img src="../../assets/images/workOrderReview/back.png" alt="">
      </div>
      <div class="backText">{{$t('lang.workOrderReview.backText')}}</div>
    </div>
    <div class="body">
      <div class="pageBody">
        <div class="ProblemBox">
          <div class="submitProblemBox">
            <div class="text1">
              <div class="messageIcon" @click="goto('workOrderMessage')">
                <img src="../../assets/images/workOrderReview/Vector.png" alt="">
                <div class="redIcon" v-if="count>0">{{count>99? '99+' : count}}</div>
              </div>
              <span> {{$t('lang.workOrderReview.SubmitProblem')}}</span>
            </div>
            <div class="text2">{{$t('lang.workOrderReview.NotCredited')}}</div>
            <div class="text3" @click="getTicketCount()">{{$t('lang.workOrderReview.UploadVouchers')}}</div>
          </div>
        </div>
        <div class="tabBar">
          <div :class="active===0?'tabed':'tab'" @click="()=>{
            active = 0
            Type = 'deposit'
             Skip = 0
             Take = 10
             check = 0
             list = []
            getList();
          }">{{$t('lang.workOrderReview.DepositIssue')}}</div>
          <div :class="active===1?'tabed':'tab'" @click="()=>{
            active = 1
            this.Type = 'withdrawal'
             Skip = 0
             Take = 10
             check = 0
             list = []
            getList();
          }">{{$t('lang.workOrderReview.WithdrawalIssue')}}</div>
        </div>
        <div class="searchBox">
          <img class="searchIcon" src="../../assets/images/workOrderReview/search.png" alt="">
          <input @keydown.enter="getList(true)" v-model="Keyword" @input="filterChineseCharacters" :placeholder="$t('lang.workOrderReview.searchPlaceholder')" class="search" type="text">
        </div>
        <div class="listView">
          <div class="listHead">
            <div class="item" @click="checkBar('Pending')">{{ $t('lang.workOrderReview.Pending') }}</div>
            <div class="item" @click="checkBar('Completed')">{{ $t('lang.workOrderReview.Completed') }}</div>
            <div class="item" @click="checkBar('All')">{{ $t('lang.workOrderReview.All') }}</div>
            <div class="bar" :style="{left: barRemoveVal+'%'}"></div>
          </div>
          <Loadmore
            :bottomPullText="$t('lang.loadingStatus.pullToLoad')"
            :bottomDropText="$t('lang.loadingStatus.releaseToLoad')"
            :bottomLoadingText="$t('lang.loadingStatus.loading')"
            :auto-fill="false"
            :bottom-method="getList"
            :bottom-all-loaded="hasLoadAll"
            ref="loadmore">
          <div class="viewContent">
              <div class="detailBox" v-for="(item) in list" :key="item.id">
                <div class="row1">
                  <div class="leftBox">
                    <div class="typeTitle">{{$t('lang.UploadProofDetail.BillNumber')}}: {{item.TransactionUuid}}</div>
                    <div class="status" v-if="item.TicketStatus === 1 || item.TicketStatus === 2">{{$t('lang.workOrderReview.Completed')}}</div>
                    <div class="status" v-if="item.TicketStatus === 0">{{$t('lang.workOrderReview.Pending')}}</div>
                  </div>
                  <div class="rightBox" @click="goDetali(item)">
                    <span> {{$t('lang.UploadProofDetail.viewDetails')}}</span> &nbsp;>
                  </div>
                </div>
                <div class="lableRow">
                  <div class="label">{{$t('lang.UploadProofDetail.Amount')}}:</div>
                  <div class="value">₹{{item.Amount}}</div>
                </div>
                <div class="lableRow">
                  <div class="label">{{$t('lang.UploadProofDetail.SubmissionTime')}}:</div>
                  <div class="value">{{formatDate(item.CreateTime)}}</div>
                </div>
                <div class="lableRow">
                  <div class="label">{{$t('lang.UploadProofDetail.issue')}}:</div>
                  <div class="value">{{item.Issue}}</div>
                </div>
                <div class="detailBoxTip">
                  {{$t('lang.UploadProofDetail.detailBoxTip')}}
                </div>
              </div>
            <div class="noData" v-if="list.length===0">
              <div class="noDataTip">{{$t('lang.workOrderReview.NotCredited')}}</div>
              <span class="noDataTo" @click="getTicketCount()">{{$t('lang.workOrderReview.UploadVouchers')}}</span>
            </div>
          </div>
          </Loadmore>

        </div>
      </div>
    </div>
    <div class="messageMarsk" v-show="meassgeShow">
      <div class="messageBox">
        <div class="title">{{$t('lang.workOrderReview.OrderType')}}</div>
        <div class="actionBtnBox">
          <div class="btn" @click="goUploadProof('D')">{{$t('lang.workOrderReview.DepositIssue')}}</div>
          <div class="btn" @click="goUploadProof('W')">{{$t('lang.workOrderReview.WithdrawalIssue')}}</div>
        </div>
        <img @click="meassgeShow = false" class="closeIcon" src="../../assets/images/workOrderReview/close.png" alt="">
      </div>
    </div>
    <div class="messageMarsk2" v-show="meassgeShow2">
      <div class="messageBox">
        <div class="title">{{$t('lang.workOrderReview.applicationLimit')}}</div>
        <div class="actionBtnBox">
          <div class="btn" @click="meassgeShow2 = false">{{$t('lang.workOrderReview.ok')}}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {Loadmore} from 'mint-ui'
import request from '@/service'
import showMore from '@/assets/images/common/showMore.gif'
export default {
  name: 'workOrderReview',
  components: {
    Loadmore
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.Skip = 0
      vm.Take = 10
      vm.check = 0
      vm.list = []
      vm.getList()
      vm.getMessageCount()
    })
  },
  data () {
    return {
      Skip: 0,
      Take: 10,
      check: 0,
      list: [],
      hasLoadAll: true,
      firstLoad: true,
      showMore,
      active: 0,
      count: 0,
      meassgeShow: false,
      meassgeShow2: false,
      Type: 'deposit',
      barRemoveVal: 0,
      TicketStatus: 'pending',
      Keyword: ''
    }
  },
  watch: {
    '$store.state.locale': function () {

    }
  },
  mounted () {},
  methods: {
    getTicketCount () {
      let url = 'innovation/get/ticket/count'
      let data = {
        UserId: JSON.parse(localStorage.getItem('userInfo')).UserId
      }
      request('post', url, data, false).then(res => {
        if (res.Code === 1) {
          if (res.TicketCount >= 5) {
            this.meassgeShow2 = true
          } else {
            this.meassgeShow = true
          }
        }
      }).catch(err => {
        console.log(err)
      })
    },
    filterChineseCharacters (event) {
      const value = event.target.value
      this.Keyword = value
      // // 正则表达式，匹配中文字符和中文标点符号
      // const chineseRegex = /[\u4e00-\u9fa5|\u3002|\uff1f|\uff01|\uff0c|\u3001|\uff1b|\uff1a|\u201c|\u201d|\u2018|\u2019|\uff08|\uff09|\u300a|\u300b|\u3008|\u3009|\u3010|\u3011|\u300e|\u300f|\u300c|\u300d|\ufe43|\ufe44|\u3014|\u3015|\u2026|\u2014|\uff5e|\ufe4f|\uffe5]/g
      // // 移除中文字符和中文标点符号
      // this.Keyword = value.replace(chineseRegex, '')
    },
    checkBar (type) {
      this.Skip = 0
      this.Take = 10
      this.check = 0
      this.list = []
      if (type === 'Pending') {
        this.barRemoveVal = 0
        this.TicketStatus = 'pending'
        this.getList()
      } else if (type === 'Completed') {
        this.barRemoveVal = 33.33
        this.TicketStatus = 'done '
        this.getList()
      } else {
        this.barRemoveVal = 66.66
        this.TicketStatus = 'all'
        this.getList()
      }
    },
    formatDate (originalDateString) {
      if (!originalDateString) {
        return null
      }
      // 创建 Date 对象
      const date = new Date(originalDateString)
      // 从 Date 对象获取年、月、日、时、分、秒
      const year = date.getFullYear()
      // 注意，月份从 0 开始，所以要加 1
      const month = date.getMonth() + 1
      const day = date.getDate()
      const hours = date.getHours()
      const minutes = date.getMinutes()
      const seconds = date.getSeconds()
      // 将月份、日期、小时、分钟和秒格式化成两位数
      const formattedMonth = month < 10 ? `0${month}` : `${month}`
      const formattedDay = day < 10 ? `0${day}` : `${day}`
      const formattedHours = hours < 10 ? `0${hours}` : `${hours}`
      const formattedMinutes = minutes < 10 ? `0${minutes}` : `${minutes}`
      const formattedSeconds = seconds < 10 ? `0${seconds}` : `${seconds}`
      // 返回格式化的日期时间字符串
      // return `${formattedMonth}/${formattedDay}/${year} ${formattedHours}:${formattedMinutes}:${formattedSeconds}`
      return `${year}-${formattedMonth}-${formattedDay} ${formattedHours}:${formattedMinutes}:${formattedSeconds}`
    },
    goBack () {
      this.$router.push('Support')
      // this.$router.back()
    },
    goto (path) {
      this.$router.push(path)
    },
    goDetali (item) {
      sessionStorage.setItem('DetailShowType', 1)
      sessionStorage.setItem('TransactionData', JSON.stringify(item))
      if (item.TicketType === 'deposit') {
        this.$router.push('UploadproofDepositDetail')
      } else {
        this.$router.push('UploadproofWithdrawDetail')
      }
    },
    goUploadProof (type) {
      sessionStorage.setItem('ProofType', type)
      this.meassgeShow = false
      this.$router.push('/Uploadproof')
      // if (type === 'W') {
      //   if (JSON.parse(localStorage.getItem('userInfo')) && JSON.parse(localStorage.getItem('userInfo')).UserShowId) {
      //     window.LiveChatWidget.call('set_customer_name', JSON.parse(localStorage.getItem('userInfo')).UserShowId)
      //   } else {
      //     window.LiveChatWidget.call('set_customer_name', ' ')
      //   }
      //   window.LiveChatWidget.call('maximize')
      // } else {
      //   sessionStorage.setItem('ProofType', type)
      //   this.meassgeShow = false
      //   this.$router.push('/Uploadproof')
      // }
    },
    getMessageCount () {
      let url = 'innovation/ticket/unread/message/count'
      let data = {
        UserId: JSON.parse(localStorage.getItem('userInfo')).UserId
      }
      request('post', url, data, false).then(res => {
        if (res) {
          this.count = res.Count
        }
      }).catch(err => {
        console.log(err)
      })
    },
    getList (keyDown) {
      let url = '/innovation/ticket/list'
      if (keyDown) {
        this.Skip = 0
        this.Take = 10
        this.check = 0
        this.list = []
      }
      let data = {
        Type: this.Type,
        TicketStatus: this.TicketStatus,
        Skip: this.Skip,
        Take: this.Take,
        Keyword: this.Keyword,
        UserId: JSON.parse(localStorage.getItem('userInfo')).UserId
      }
      request('post', url, data, false).then(res => {
        if (res) {
          // this.list = res.TicketList
          if (this.check > 0) {
            this.list = res.TicketList
          } else {
            this.list = this.list.concat(res.TicketList)
          }
          this.Skip += this.Take
          this.hasLoadAll = this.Skip >= res.Total
          if (!this.firstLoad) {
            this.$refs.loadmore.onBottomLoaded()
          }
          this.firstLoad = false
          this.check = 0
        }
      }).catch(err => {
        console.log(err)
      })
    }
  }
}
</script>

<style lang="less" scoped>
.GdPage {
  position: relative;
  top: -10px;
  height: 80vh;
  //border: 1px solid red;
  .back{
    height: 6.11vw;
    display: flex;
    align-items: center;
    margin-top: 22vw;

    .backIcon{
      margin-left: 5vw;

    }
    .backText{
      margin-left: 5vw;
      color: #F6D9AA;
      font-weight: 700;
      font-size: 5.27vw;
    }
  }
  .body{}
  .ProblemBox{
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    .submitProblemBox{
      width: 93.33vw;
      height: 32.5vw;
      border-radius: 2.22vw;
      background: linear-gradient(to bottom, #212121, #1D1D1D);
      position: relative;
      top: 4vw;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: space-around;
      position: relative;
      .text1{
        color: #ECECEC;
        font-size: 4.72vw;
        font-weight: 700;
        span{
          position: relative;
          top: 2vw;
        }
        .messageIcon{
          position: absolute;
          top: 4vw;
          left: 84vw;
          .redIcon{
            background: #F23042;
            height: 3.769vw;
            width: 3.769vw;
            font-size: 1.80vw;
            display: flex;
            align-items: center;
            justify-content: center;
            border-radius: 50vw;
            position: absolute;
            left: 4vw;
            top: -1vw;
          }
        }
      }
      .text2{
        //margin-top: -5vw;
        color: #ECECEC;
        font-size: 3.888vw;
      }
      .text3{
        position: relative;
        top: -5vw;
        border-bottom: 1px solid #21B2F2;
        font-size: 3.61vw;
        color: #21B2F2;
      }
    }
  }
  .tabBar{
    display: flex;
    width: 100%;
    position: relative;
    top: 10vw;
    .tab{
      flex: 1;
      height: 10vw;
      background: #222222;
      color: #666666;
      font-size: 3.61vw;
      font-weight: 700;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 3vw 3vw 0 0;
      transition: all 0.3s ease;
    }
    .tabed{
      flex: 1;
      height: 10vw;
      background: #F6D9AA;
      color: #000000;
      font-size: 3.61vw;
      font-weight: 700;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 3vw 3vw 0 0;
      transition: all 0.2s ease;
    }
  }
  .searchBox{
    position: relative;
    margin: 5vw;
    top: 8vw;
    .searchIcon{
      position: absolute;
      top: 1.8vw;
      left: 2vw;
    }
    .search{
      text-indent: 8vw;
      border: none;
      background: #fff;
      width: 100%;
      height: 8.05vw;
      border-radius: 1vw;
    }
  }
  .listView{
    width: 100%;
    position: relative;
    top: 10vw;
    .listHead{
      display: flex;
      justify-content: space-around;
      padding-bottom: 1vw;
      margin-left: 3.5vw;
      margin-right: 3.5vw;
      position: relative;
      .bar{
        position: absolute;
        height: .6vw;
        width: 33.333%;
        background-color: #F6D9AA;;
        left: 0;
        bottom: -0.8vw;
        border-radius: 2vw;
        transition: all 0.2s ease;
      }
      .item{
        //border: 1px solid red;
        display: flex;
        justify-content: center;
        align-items: center;
        flex: 1;
      }
    }
    .viewContent{
      margin-top: 2vw;
      display: flex;
      flex-direction: column;
      align-items: center;
      //border: 1px solid red;
      height: 49vh;
      overflow-y: auto;
      //border: 1px solid red;
      padding-bottom: 2vw;
      .detailBox{
        margin-top: 2vw;
        flex: none;
        width: 91.077vw;
        height: 41.666vw;
        border-radius: 3.166vw;
        background: #222222;
        display: flex;
        flex-direction: column;
        justify-content: space-around;
        .row1{
          display: flex;
          justify-content: space-between;
          margin-top: 1vw;
          .leftBox{
            display: flex;
            align-items: center;
            font-size: 3.666vw;
            color: #fff;
            font-weight: 700;
            img{
              margin-left: 3vw;
            }
            .typeTitle{
              //border: 1px solid;
              margin-left: 2.5vw;
              width: 41.7vw;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            }
            .status{
              background-color: #F6D9AA;
              color: #000;
              font-size: 3vw;
              font-weight: 500;
              padding: 0.5vw 1vw;
              margin-left: 2vw;
              border-radius: 0.833vw;
            }
          }
          .rightBox{
            display: flex;
            align-items: center;
            color: #02A7F0;
            margin-right: 3vw;
            font-size: 3vw;
            span{
              border-bottom: 1px solid;
            }

          }
        }
        .detailBoxTip{
          text-align: center;
          font-size: 2.77vw;
          color: #F6D9AA;
          border-top: 1px solid rgb(90,90,90);
          margin:0 2vw;
          padding-top: 2vw;
        }
        .lableRow{
          margin-left: 3vw;
          font-size: 3.611vw;
          display: flex;
          .label{
            color: rgb(121,121,121);
            width: 31.72vw;
            font-weight: bold;
          }
          .value{
            margin-left: 2vw;
            color: #fff;
            max-width: 50vw;
            //border: 1px solid red;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          }
        }
      }
    }

    .noData{
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      position: relative;
      top: 10vw;
      .noDataTip{
        color: #ECECEC;
        font-size: 3.888vw;
      }
      .noDataTo{
        //position: relative;
        //top: -5vw;
        border-bottom: 1px solid #21B2F2;
        font-size: 3.61vw;
        color: #21B2F2;
      }
    }
  }
  .messageMarsk{
    position: absolute;
    top: -19vw;
    z-index: 5;
    height: 100vh;
    width: 100%;
    background: rgba(0,0,0,.5);
    display: flex;
    justify-content: center;
    align-items: center;
   .messageBox{
    width: 82.233vw;
    height: 54.444vw;
     background: rgb(25,26,25);
     border-radius: 4.16vw;
     border: 1px solid #737373;
     position: relative;
     display: flex;
     flex-direction: column;
     align-items: center;
     .title{
       color:#D9D9D9;
       font-size: 4.72vw;
       font-weight: 700;
       position: relative;
       top: 10vw;
     }
     .actionBtnBox{
       position: relative;
       top: 19vw;
       display: flex;
       flex-direction: column;
       justify-content: space-around;
       height: 26vw;
       //border: 1px solid red;
       .btn{
         background-color:#F1DAB0;
         color: #000000;
         display: flex;
         align-items: center;
         justify-content: center;
         width: 67.05vw;
         height: 9.436vw;
         border-radius: 1.388vw;
       }
     }
     .closeIcon{
       position: absolute;
       left: 1vw;
       top: 1vw;
       left: 40.5vw;
       top: 58vw;
     }
   }
  }
  .messageMarsk2{
    position: absolute;
    top: -19vw;
    z-index: 5;
    height: 100vh;
    width: 100%;
    background: rgba(0,0,0,.5);
    display: flex;
    justify-content: center;
    align-items: center;
    .messageBox{
      width: 82.233vw;
      height: 54.444vw;
      background: rgb(25,26,25);
      border-radius: 4.16vw;
      border: 1px solid #737373;
      position: relative;
      display: flex;
      flex-direction: column;
      align-items: center;
      .title{
        color:#D9D9D9;
        font-size: 4.72vw;
        font-weight: 700;
        position: relative;
        top: 10vw;
        width: 65.94vw;
        text-align: center;
      }
      .actionBtnBox{
        position: relative;
        top: 19vw;
        display: flex;
        flex-direction: column;
        justify-content: space-around;
        height: 26vw;
        //border: 1px solid red;
        .btn{
          background-color:#F1DAB0;
          color: #000000;
          display: flex;
          align-items: center;
          justify-content: center;
          width: 67.05vw;
          height: 9.436vw;
          border-radius: 1.388vw;
        }
      }
      .closeIcon{
        position: absolute;
        left: 1vw;
        top: 1vw;
        left: 40.5vw;
        top: 58vw;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/workOrderReview/index.vue